import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-771b4a71"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Reservations", -1))
const _hoisted_2 = {
  key: 0,
  class: "info-message"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Marketplace Reservations ")
const _hoisted_4 = {
  key: 2,
  class: "container"
}
const _hoisted_5 = { class: "row form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 4 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Name")
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Phone", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Phone")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Cell Phone")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Email")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Unit Name")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Unit Size")
], -1))
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Move-In Date", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Notes", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = { key: 7 }
const _hoisted_32 = { key: 8 }
const _hoisted_33 = { key: 9 }
const _hoisted_34 = { key: 10 }
const _hoisted_35 = { key: 11 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_38 = {
  key: 3,
  class: "custom-box delete-box"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to cancel reservation?", -1))
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 5,
  class: "custom-box delete-box"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to delete?", -1))
const _hoisted_43 = { class: "form-delete" }
const _hoisted_44 = { class: "form-field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Reason", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  key: 5,
  class: "text-center",
  style: {"margin-top":"15px"}
}
const _hoisted_48 = { key: 6 }

import { computed, onMounted, ref } from "vue";

import { get } from "../../src/methods/api";
import api from "@virgodev/bazaar/functions/api";
import {
  CustomerDataInterface,
  ReservationInterface,
  UnitTypeInterface,
} from "@/types/customers";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { UnitInterface } from "@/types/unit";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const status = ref("loading");
const searchCustomer = ref("");
const customers = ref(Array<CustomerDataInterface>());
const reservations = ref(Array<ReservationInterface>());
const filteredReservations = ref(Array<ReservationInterface>());
const errors = ref("");
const units = ref(Array<UnitInterface>());
const storedge = ref(false);
const selectedFilter = ref("name");
const unitTypes = ref();
const formSubmitting = ref(false);
const selectedCloseReason = ref();
const showDelete = ref(false);
const selectedReserved = ref<ReservationInterface>();
const reasons = ref();
const filterOptions = ref([
  { text: "Name", value: "name" },
  { text: "Phone or Cell Phone", value: "phone" },
]);


// A reservation's note reaches us either as free text (CC Storage's waiting-list
// `notes`) or as StorEdge's list of note records, so render whichever arrived.
function reservationNotes(reservation: ReservationInterface) {
  const notes = reservation.notes;
  if (!notes) {
    return "";
  }
  if (Array.isArray(notes)) {
    return notes
      .map((entry) => (typeof entry === "string" ? entry : entry.note || ""))
      .filter((text) => text)
      .join("; ");
  }
  return typeof notes === "string" ? notes : "";
}

// Only providers that actually send notes get the column, so no other
// facility's table gains an empty one.
const showNotes = computed(() =>
  reservations.value.some((reservation) => reservationNotes(reservation))
);

// A CC Storage waiting-list entry is a request for a move-in date, so that
// date is the point of the row. Sitelink sends the same field as
// "YYYY-MM-DD HH:MM:SS", so only the date part is shown.
function moveInDate(reservation: ReservationInterface) {
  const value = reservation.desired_move_in_date;
  if (!value) {
    return "";
  }
  return String(value).slice(0, 10);
}

// Same rule as the notes column: only providers that send a date get it.
const showMoveInDate = computed(() =>
  reservations.value.some((reservation) => moveInDate(reservation))
);

// Facilities without a reservations concept (CC Storage, Cubby) show a plain
// notice instead of loading a list that would only error — driven by the
// per-provider show_reservations flag rather than a facility-name check.
const notUtilized = computed(() => !api_settings.show_reservations);

onMounted(async () => {
  await router.isReady();
  if (notUtilized.value) {
    status.value = "completed";
    return;
  }
  await getReservations();
});

async function getUnits() {
  errors.value = "";
  const response = await api({
    url: `units/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getReasons() {
  errors.value = "";
  const response = await api({
    url: `reasons/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    reasons.value = response.body.reasons;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
if (props.facilityName == "Storedge") {
  getReasons();
}
async function search() {
  if (searchCustomer.value.length) {
    let searchValue = searchCustomer.value.trim();
    if (selectedFilter.value == "name") {
      if (storedge.value) {
        filteredReservations.value = reservations.value.filter(
          (item: ReservationInterface) =>
            (item.tenant.first_name + " " + item.tenant.last_name)
              .toLowerCase()
              .includes(searchValue.toLowerCase())
        );
      } else {
        filteredReservations.value = reservations.value.filter(
          (item: ReservationInterface) =>
            item.customer &&
            item.customer.name.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
    } else {
      if (storedge.value) {
        filteredReservations.value = reservations.value.filter(
          (item: ReservationInterface) =>
            item.tenant.phone_numbers
              .map((num) => num.unformatted_number)
              .toString()
              .includes(searchValue) ||
            item.tenant.phone_numbers
              .map((num) => num.formatted_number)
              .toString()
              .includes(searchValue)
        );
      } else {
        filteredReservations.value = reservations.value.filter(
          (item: ReservationInterface) =>
            (item.customer &&
              item.customer.cell_phone &&
              item.customer.cell_phone.includes(searchValue)) ||
            (item.customer &&
              item.customer.phone &&
              item.customer.phone.includes(searchValue))
        );
      }
    }
  } else {
    filteredReservations.value = reservations.value;
  }
}

async function getCustomers() {
  let url = `customers/?facilityId=${props.facilityId}&include=meta`;
  let response = await get(url);
  if (response) {
    if (response.tenants) {
      customers.value = response.tenants;
      storedge.value = true;
    } else {
      customers.value = response;
    }
  }
}
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getReservations() {
  await getUnits();
  let url = `list_reservations/?facilityId=${props.facilityId}`;
  if (props.facilityName == "ESS") {
    url = `reservations/?facilityId=${props.facilityId}`;
  }
  const response = await api({
    url: url,
  });
  if (response.status == 200) {
    if (response.body.leads) {
      reservations.value = response.body.leads;
      storedge.value = true;
    } else {
      await getCustomers();
      await getUnitTypes();

      reservations.value = response.body;
      if (api_settings.tenant_search_with_reservations) {
        reservations.value = reservations.value.filter(
          (reservation) => reservation.active
        );
        if (reservations.value.length > 30) {
          reservations.value = reservations.value.splice(0, 30);
        }
      }

      for (let reservation of reservations.value) {
        if (api_settings.tenant_search_with_reservations) {
          const responseReserve = await api({
            url: `customers/?id=${reservation.customer_id}&facilityId=${props.facilityId}`,
          });
          if (responseReserve.status == 200) {
            reservation.customer = responseReserve.body[0];
          } else {
            reservation.customer = null;
          }
        } else {
          let customer = customers.value.filter(
            (customer: CustomerDataInterface) =>
              customer.id == reservation.customer_id
          )[0];
          if (customer) {
            reservation.customer = customer;
          } else {
            reservation.customer = null;
          }
        }
        if (!reservation.unit) {
          reservation.unit = units.value.filter(
            (item: UnitInterface) => item.id == reservation.unit_id.toString()
          )[0];
          if (reservation.unit && reservation.unit.unit_type_id) {
            reservation.size = unitTypes.value.filter(
              (item: UnitTypeInterface) =>
                item.id == reservation.unit.unit_type_id.toString()
            )[0];
          }
        }
      }
      if (api_settings.tenant_search_with_reservations) {
        reservations.value = reservations.value.filter(
          (item) => item.unit && item.unit.unit_type_id
        );
      }
    }

    filteredReservations.value = reservations.value;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "completed";
}
async function cancelReservation() {
  if (selectedReserved.value) {
    formSubmitting.value = true;
    errors.value = "";
    let json;
    if (props.facilityName == "Storedge") {
      json = JSON.parse(
        JSON.stringify({
          lead: {
            close_reason_id: selectedCloseReason.value.id,
          },
        })
      );
    }
    if (props.facilityName == "Sitelink") {
      json = JSON.parse(
        JSON.stringify({
          needed: selectedReserved.value.desired_move_in_date.replace(" ", "T"),
          customer_id: selectedReserved.value.customer_id,
        })
      );
    }
    let url = `reservations/?id=${selectedReserved.value.id}&facilityId=${props.facilityId}&unit_id=${selectedReserved.value.unit_id}`;

    const response = await api({
      url: url,
      method: "DELETE",
      json,
    });
    if (response.status == 200) {
      reservations.value.splice(
        reservations.value.indexOf(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          reservations.value.find(
            (item: ReservationInterface) => item == selectedReserved.value
          )
        ),
        1
      );
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
    formSubmitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(notUtilized))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " This facility does not utilize reservations. "))
      : _createCommentVNode("", true),
    (!_unref(notUtilized) && _unref(api_settings).marketplace_reservations)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          class: "btn btn-blue",
          to: {
      name: 'marketplace_reservations',
      params: { facilityName: __props.facilityName, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (!_unref(notUtilized) && _unref(api_settings).reservation_search)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchCustomer).value = $event)),
              type: "text",
              style: {"max-width":"840px"},
              placeholder: "Search...",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (search()), ["enter"]))
            }, null, 544), [
              [_vModelText, searchCustomer.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFilter).value = $event)),
              class: "form-select",
              style: {"max-width":"210px"},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (search()), ["enter"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filter) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: filter + 'filter',
                  value: filter.value
                }, _toDisplayString(filter.text), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, selectedFilter.value]
            ]),
            _createElementVNode("button", {
              class: "btn",
              onClick: search
            }, "Search")
          ])
        ]))
      : _createCommentVNode("", true),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 3,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (filteredReservations.value && filteredReservations.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            (filteredReservations.value[0].tenant)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, _hoisted_11))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_12,
                  _hoisted_13
                ], 64)),
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            (_unref(showMoveInDate))
              ? (_openBlock(), _createElementBlock("th", _hoisted_17, _hoisted_19))
              : _createCommentVNode("", true),
            (_unref(showNotes))
              ? (_openBlock(), _createElementBlock("th", _hoisted_20, _hoisted_22))
              : _createCommentVNode("", true),
            _hoisted_23
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReservations.value, (reservation) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: reservation.id + 'customer'
            }, [
              _createElementVNode("td", null, [
                (reservation.customer && reservation.customer.id)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      to: {
            name: _unref(api_settings).tenant_search_with_reservations
              ? 'customer_detail_storedge'
              : 'customer_detail_ess',
            params: {
              id: reservation.customer.id,
              facilityId: __props.facilityId,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reservation.customer.name ||
            reservation.customer.first_name +
              " " +
              reservation.customer.last_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (reservation.tenant)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 1,
                        to: {
            name: 'customer_detail_storedge',
            params: _unref(api_settings).use_contact_id
              ? {
                  id: reservation.tenant.id,
                  facilityId: __props.facilityId,
                  contactId: reservation.tenant.id,
                }
              : {
                  id: reservation.tenant.id,
                  facilityId: __props.facilityId,
                },
          }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(reservation.tenant.first_name) + " " + _toDisplayString(reservation.tenant.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
              ]),
              (reservation.tenant && reservation.tenant.phone_numbers)
                ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservation.tenant.phone_numbers, (phone) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: phone.id + 'phone'
                      }, [
                        _createTextVNode(_toDisplayString(phone.formatted_number) + " - " + _toDisplayString(phone.label), 1),
                        _hoisted_25
                      ]))
                    }), 128))
                  ]))
                : (reservation.customer)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("td", null, _toDisplayString(reservation.customer.formatted_phone), 1),
                      _createElementVNode("td", null, _toDisplayString(reservation.customer.formatted_cell_phone), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock("td", _hoisted_26)),
              (reservation.tenant)
                ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(reservation.tenant.email), 1))
                : (reservation.customer && reservation.customer.email)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(reservation.customer.email), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_29)),
              (reservation.unit)
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(reservation.unit.name), 1))
                : _createCommentVNode("", true),
              (
          reservation.size && reservation.size.length && reservation.size.width
        )
                ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                    _createTextVNode(_toDisplayString(reservation.size.length) + "x" + _toDisplayString(reservation.size.width) + " ", 1),
                    (reservation.size.height)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("x " + _toDisplayString(reservation.size.height), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (reservation.size)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(reservation.size), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_33)),
              (_unref(showMoveInDate))
                ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(moveInDate(reservation) || "—"), 1))
                : _createCommentVNode("", true),
              (_unref(showNotes))
                ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(reservationNotes(reservation) || "—"), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                (
            formSubmitting.value &&
            selectedReserved.value &&
            selectedReserved.value.id == reservation.id
          )
                  ? (_openBlock(), _createBlock(BaseSpinner, {
                      key: 0,
                      preset: "large"
                    }))
                  : _createCommentVNode("", true),
                (__props.facilityName == 'ESS')
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 1,
                      disabled: formSubmitting.value,
                      class: "btn btn-blue",
                      to: {
            name: 'rental',
            params: {
              facilityId: __props.facilityId,
              customerId: reservation.customer_id,
              unitType: reservation.unit.unit_type_id,
              unitId: reservation.unit.id,
              unitStatus: 'reserved',
              reservationId: reservation.id,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 2
                    }, 1032, ["disabled", "to"]))
                  : (reservation.unit && _unref(api_settings).complete_reservations)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 2,
                        disabled: formSubmitting.value,
                        class: "btn btn-blue",
                        to: {
            name: 'rental_storedge',

            params: _unref(api_settings).tenant_search_with_reservations
              ? {
                  facilityId: __props.facilityId,
                  customerId: reservation.customer_id,
                  unitType: reservation.unit.unit_type_id,
                  unitId: reservation.unit.id,
                  reservationId: reservation.id,
                  unitStatus: 'reserved',
                }
              : {
                  facilityId: __props.facilityId,
                  customerId: reservation.tenant.id,
                  unitType: reservation.unit
                    ? reservation.unit.unit_type.id ||
                      reservation.unit.unit_type_id
                    : '',
                  unitId: reservation.unit.id,
                  reservationId: reservation.id,
                  unitStatus: 'reserved',
                },
          }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 2
                      }, 1032, ["disabled", "to"]))
                    : _createCommentVNode("", true),
                (
            showDelete.value &&
            selectedReserved.value == reservation &&
            !_unref(api_settings).show_cancel_reasons
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", {
                        class: "btn btn-primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (cancelReservation()))
                      }, "Yes"),
                      _createElementVNode("div", {
                        class: "btn btn-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (showDelete.value = false))
                      }, "No")
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      class: "btn btn-transparent",
                      onClick: ($event: any) => ((showDelete.value = true), (selectedReserved.value = reservation))
                    }, " Cancel ", 8, _hoisted_40)),
                (
            showDelete.value &&
            selectedReserved.value &&
            selectedReserved.value.id == reservation.id &&
            _unref(api_settings).show_cancel_reasons
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedCloseReason).value = $event)),
                            class: "form-select",
                            required: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasons.value, (reason) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: reason.id + 'reason'
                              }, [
                                (reason.kind == 'close')
                                  ? (_openBlock(), _createElementBlock("option", {
                                      key: 0,
                                      value: reason
                                    }, _toDisplayString(reason.reason), 9, _hoisted_46))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, selectedCloseReason.value]
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-outline-blue",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (cancelReservation()))
                        }, " Finish "),
                        _createElementVNode("div", {
                          class: "btn btn-outline-blue",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDelete.value = false))
                        }, " Cancel ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (status.value == 'completed' && !_unref(notUtilized))
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, " No results found "))
        : _createCommentVNode("", true),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})